export const HOME_FAIL_COMMENTS_DETAILS =
  "사장님 사이트로 댓글을 전송했으나 등록에 실패했어요. 사유를 살펴보고 조치를 해 주세요.";
export const HOME_SPECIAL_REVIEWS_DETAILS =
  "음식에 대한 고객의 피드백이나 악성 리뷰 등 사장님의 관심이 필요한 리뷰예요.";
export const HOME_UNANSWER_REVIEWS_DETAILS =
  "고객이 남긴 모든 리뷰에 빠짐없이 댓글을 등록하시면 매출 증가에 도움을 줄 수 있어요.";
export const HOME_PENDING_COMMENTS_DETAILS =
  "댓글이 사장님 사이트에 곧 등록될 예정이에요. 등록 이후엔 수정이 불가하니 댓글을 검토해 주세요.";

export const PENDING_COMMENTS = "등록 대기 댓글";
export const UNANSWERED_REVIEWS = "미답변 리뷰";
export const SPECIAL_REVIEWS = "관심 리뷰";
export const FAILED_COMMENTS = "등록 실패 댓글";
export const GENERAL_REVIEWS = "일반 리뷰";

export const R_GENERAL = "일반 리뷰";
export const R_SPECIAL = "관심 리뷰";
export const R_SETTING = "댓글 설정";
export const R_ANALYTICS = "리뷰 분석";

export const A_MONTHLY = "월간 리포트";
export const A_SELLING = "매출 분석";
export const A_FLAG = "깃발 분석";

export const BTN_CANCEL = "취소";
export const BTN_APPLY = "적용";

export const HOUR = "시간";
export const MINUTE = "분";
export const DAY = "일 0시간";

export const EDIT = "수정 하기";
export const EXCLUDE = "댓글 등록 제외";

// Pending comments
// Unanswered reviews
// Special reviews
// Failed comments

// PendingComments
// UnansweredReviews
// SpecialReviews
// FailedComments
export const MORE = "더 보기";
export const THIS_IS_THE_LAST_REVIEW = "마지막 리뷰 입니다.";
export const AI_COMMENT = "추천 댓글";
export const CEO_COMMENT = "사장님";
export const POST_COMMENT_FAIL = "❗ 댓글 등록에 실패했어요.";
export const THIS_REVIEW_ALREADY_REPLIED = "사장님 사이트에 이미 등록된 댓글이 있어요.";
export const POST_AGAIN = "등록 재요청";
export const POST = "등록 요청";
export const TIME_IS_EXPIRED = "🥺 댓글 등록 기간이 만료되었어요.";
export const THIS_IS_EXCLUDED_REVIEW = "🙏 댓글 등록이 제외된 리뷰예요.";
export const WRITE_COMMENT_BTN = "댓글 작성하기";
export const WRITE_COMMENT = "댓글 작성";

export const DELETE_ALL = "지우기";
export const APPLY_FREE_TRIAL = "무료 체험 신청하기";

export const NO_USE = "사용 안 함";
export const AFTER_1_DAY = "1일 후";
export const AFTER_2_DAYS = "2일 후";
export const AFTER_3_DAYS = "3일 후";
export const AFTER_4_DAYS = "4일 후";
export const AFTER_5_DAYS = "5일 후";

export const AUTO_POST_COMMENT_DAYS = "댓글 자동 등록일";
export const SAVE = "저장";
export const ADDITIONAL_COMMENT_SETTINGS = "추가 댓글 설정";

export const TITLE = "제목";
export const CONTENT = "댓글 내용";
export const SELECT_ALL = "전체 선택";
export const CANT_SEE_SOME_STORES = "일부 매장이 보이지 않나요?";

export const APPLY_TO_STORE = "적용 매장";
export const TOTAL_APPLY = '총 $1개 매장에 적용';